import { render, staticRenderFns } from "./RightSideDrawer.vue?vue&type=template&id=25bca15c&"
import script from "./RightSideDrawer.vue?vue&type=script&lang=js&"
export * from "./RightSideDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
installComponents(component, {
  VList,
  VNavigationDrawer,
})
